<div mode="card">
    <div class="ItemSearch">
      <h3>Assign claim question</h3>
    </div>
  
    <div class="qa_panel">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let item of claimQuestions; index as i" [expanded]="step === i" (opened)="setStep(i)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="question_panel">
                <input class="mat-checkbox" type="checkbox" [(ngModel)]="item.checked" (change)="toggleChildren(item, i)">
                {{ item.question }}
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="answer_panel">
            <ul>
              <li *ngFor="let answer of item.questionAnswers">
                <input class="mat-checkbox" type="checkbox" [(ngModel)]="answer.checked" (change)="updateParent(item, i)">
                <p>
                  {{ answer.answer }}
                </p>
              </li>
            </ul>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  
    <div class="flexwrap" style="margin-top: 10px;">
      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" style="width: 100%;">
        <button mat-button class="sub-button" (click)="assign()">Assign</button>
        <button mat-button class="can-button" (click)="cancel()"><span>Cancel</span></button>
      </div>
    </div>
  </div>
  